import { render, staticRenderFns } from "./KeywordActions.vue?vue&type=template&id=a40d078e"
import script from "./KeywordActions.vue?vue&type=script&lang=js"
export * from "./KeywordActions.vue?vue&type=script&lang=js"
import style0 from "./KeywordActions.vue?vue&type=style&index=0&id=a40d078e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports